module.exports = __webpack_public_path__ + "static/media/CompletoFullSize.88e248d1.png";